import React from 'react';
const DollarSignIcon = props => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-75">
      <line x1="12" y1="1" x2="12" y2="23" data-id="element-76"></line>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-77"></path>
    </svg>;
};
export default DollarSignIcon;